module.exports = __webpack_public_path__ + "static/media/b(4).9a62c6a0.png";